export default "<ng-template [cdkPortalOutlet]=\"dynamicLayoutPortal\"></ng-template>\r\n"